import React, { useMemo } from 'react';

import '../bookings/bookingsTables.css';

const DAY_LABELS = {
  MON: 'Monday',
  TUE: 'Tuesday',
  WED: 'Wednesday',
  THU: 'Thursday',
  FRI: 'Friday',
  SAT: 'Saturday',
  SUN: 'Sunday',
};

function getAssignmentDisplayValue(block = {}) {
  if (block.assignmentType === 'USER' && block?.selectedUserOption?.label) {
    return block.selectedUserOption.label;
  }

  if (block.assignmentType === 'TEXT' && String(block.textValue || '').trim()) {
    return String(block.textValue || '').trim();
  }

  return '';
}

function getAssignmentStatus(block = {}) {
  return getAssignmentDisplayValue(block) ? 'complete' : 'incomplete';
}

export default function SysManagerRotasTimetableGrid({
  blocks = [],
  dayCodes = [],
  onCellClick,
  onSetAllClick,
}) {
  const orderedDayCodes = useMemo(() => {
    const seenCodes = new Set();
    return dayCodes.filter((dayCode) => {
      if (!dayCode || seenCodes.has(dayCode)) {
        return false;
      }
      seenCodes.add(dayCode);
      return true;
    });
  }, [dayCodes]);

  const rowData = useMemo(() => {
    const groupedRows = new Map();

    blocks.forEach((block) => {
      const rowKey = `${block.period || ''}|${block.start || ''}|${block.end || ''}`;
      if (!groupedRows.has(rowKey)) {
        groupedRows.set(rowKey, {
          rowKey,
          period: block.period || '',
          start: block.start || '',
          end: block.end || '',
          cells: {},
        });
      }

      groupedRows.get(rowKey).cells[block.dayOfWeek] = block;
    });

    return Array.from(groupedRows.values());
  }, [blocks]);

  return (
    <div className='sysManager_rotas_timetableWrapper'>
      <table className='bookingsTable sysManager_rotas_timetableGrid'>
        <thead>
          <tr className='bookingsTableHeader'>
            <th>Lesson</th>
            {orderedDayCodes.map((dayCode) => (
              <th key={dayCode}>{DAY_LABELS[dayCode] || dayCode}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rowData.map((row) => (
            <tr className='bookingsTableRow' key={row.rowKey}>
              <td className='bookingsTableData'>
                <div className='sysManager_rotas_timetableRowLabel'>
                  <div className='sysManager_rotas_timetableRowText'>
                    <span>{row.period}</span>
                    <small>{row.start} - {row.end}</small>
                  </div>
                  <button
                    className='sysManager_rotas_timetableSetAllButton'
                    type='button'
                    onClick={() => onSetAllClick(row)}
                  >
                    Set
                    <br />
                    all
                  </button>
                </div>
              </td>
              {orderedDayCodes.map((dayCode) => {
                const block = row.cells[dayCode] || null;
                const assignmentStatus = getAssignmentStatus(block || {});
                const displayValue = getAssignmentDisplayValue(block || {});

                return (
                  <td className='bookingsTableSingleRoomData' key={`${row.rowKey}-${dayCode}`}>
                    {block ? (
                      <button
                        className={`sysManager_rotas_timetableCellButton sysManager_rotas_timetableCellButton--${assignmentStatus}`}
                        type='button'
                        onClick={() => onCellClick(block)}
                      >
                        <span className='sysManager_rotas_timetableCellValue'>
                          {displayValue || 'Set slot'}
                        </span>
                      </button>
                    ) : (
                      <div className='sysManager_rotas_timetableCellEmpty'>Not used</div>
                    )}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
